import fetchServer from "../fetchServer";

/**
 * GET /main/v1/account/business-change-requests
 * Admin list of business-change requests across all agents.
 */
export default async function getAllBusinessChangeRequests({
  status,
  limit,
  offset,
} = {}) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching business change requests",
    data: [],
    meta: { limit: limit ?? 20, offset: offset ?? 0, total: 0 },
  };

  try {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    if (limit != null) params.set("limit", String(limit));
    if (offset != null) params.set("offset", String(offset));
    // Prefer populated account when the API supports it
    params.set("populate", "account");

    const qs = params.toString();
    const res = await fetchServer({
      method: "GET",
      url: `/main/v1/account/business-change-requests${qs ? `?${qs}` : ""}`,
    });

    if (res?.data && !res?.data?.error) {
      const payload = res.data?.data;
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.requests)
            ? payload.requests
            : [];
      const meta = payload?.meta || res.data?.meta || {
        limit: limit ?? 20,
        offset: offset ?? 0,
        total: items.length,
      };
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: items,
        meta,
      };
    } else {
      result.msg =
        res?.data?.error || res?.data?.message || res?.error || result.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
